import React, { useEffect, useState } from 'react'
import { GetById_Reserve_Api } from '../../API/ReserveApi';
import '../../assets/css/print.css';
import { Steps } from '../Step/Steps';
import { OthersComponent } from './OthersComponent';
import { AFactorComponent } from '../Factor/AFactorComponent';
import { Col, Row } from 'antd';
import { AdditionalFilesComponent } from './AdditionalFilesComponent';
import { AdminBarComponent } from '../Admin/AdminBarComponent';
import { PaymentComponent } from './PaymentComponent';
import { EditableReserveComponent } from './EditableReserveComponent';
import { ReserveInfoComponent } from './ReserveInfoComponent';
import { ReservePlaceAndTimeComponent } from './ReservePlaceAndTimeComponent';
import { PrintReserveInfoComponent } from './PrintReserveInfoComponent';
// ====================================================================== 
export const AReserveComponent = ({
    setLoading,
    showMessage,
    reserveId,
    onBackClick,
    onFoodClick,
}) => {
    // ====================================================================== 
    const [reserve, setReserve] = useState();
    const [version, setVersion] = useState(0);
    const [printType, setPrintType] = useState('factor');
    // ======================================================================
    useEffect(() => {
        loadReserve();
    }, [version]);
    // ======================================================================    
    const loadReserve = async () => {
        setLoading(true);
        try {
            const data = await GetById_Reserve_Api(reserveId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setReserve(data.messageData.data);
            }

            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================    
    return (
        reserve ?
            <>

                {localStorage.getItem('role') == 'SuperAdmin' ||
                    localStorage.getItem('role') == 'Admin' ?
                    <AdminBarComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        reserve={reserve}
                        setVersion={setVersion}
                        version={version}
                        receptionMode={false}
                    /> : <></>
                }
                {  localStorage.getItem('role') == 'Reception' ?
                    <AdminBarComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        reserve={reserve}
                        setVersion={setVersion}
                        version={version}
                        reserveMode={false}
                        foodMode = {false}
                        receptionMode={true}
                    /> : <></>
                }

                {localStorage.getItem('role') == 'Global' &&
                    reserve.period.getAdditionalFile &&
                    reserve.reserveStatus == "FileUploadWaiting" ?
                    <>
                        <Steps
                            reserve={reserve}
                            period={reserve.period}
                            setLoading={setLoading}
                            showMessage={showMessage}
                            isShowPrint={false}
                            setPrintType={setPrintType}
                            isShowPrev={false}
                            isShowBack={true}
                            onBackClick={onBackClick}
                            isShowNext={false}
                            isEnableNext={false}
                        />
<div className="no-print">
        <br />
        {reserve?.period?.getAdditionalFile ? (
          <AdditionalFilesComponent
            reserve={reserve}
            period={reserve.period}
            setLoading={setLoading}
            showMessage={showMessage}
            />
        ) : null}
      </div>
                                              
                                <ReserveInfoComponent 
                                adminMode={true} 
                                setLoading={setLoading} 
                                reserve={reserve} 
                                showMessage={showMessage} 
                                />
                                <OthersComponent
                                        mode={'Show'}
                                        printType={printType}
                                        showTitleBar={false}
                                        setLoading={setLoading}
                                        showMessage={showMessage}
                                        reserveId={reserve.id}
                                        reserve={reserve}
                                    />
                           
                    </>
                    :
                    localStorage.getItem('role') == 'Global' &&
                        reserve.period.getAdditionalFile &&
                        reserve.reserveStatus == "PayWaiting" ?
                        <>
                            <Steps
                                reserve={reserve}
                                period={reserve.period}
                                setLoading={setLoading}
                                showMessage={showMessage}
                                isShowPrint={false}
                                setPrintType={setPrintType}
                                isShowPrev={false}
                                isShowBack={true}
                                onBackClick={onBackClick}
                                isShowNext={false}
                                isEnableNext={false}
                            />
                            <PaymentComponent
                                reserve={reserve}
                                period={reserve.period}
                                setLoading={setLoading}
                                showMessage={showMessage}
                                version={version}
                                setVersion={setVersion}
                            />
                            <ReserveInfoComponent 
                                adminMode={true} 
                                setLoading={setLoading} 
                                reserve={reserve} 
                                showMessage={showMessage} 
                                />
                                <OthersComponent
                                        mode={'Show'}
                                        printType={printType}
                                        showTitleBar={false}
                                        setLoading={setLoading}
                                        showMessage={showMessage}
                                        reserveId={reserve.id}
                                        reserve={reserve}
                                    />

                        </> :
                        <>
                            <Steps
                                reserve={reserve}
                                period={reserve.period}
                                setLoading={setLoading}
                                showMessage={showMessage}
                                isShowPrint={true}
                                setPrintType={setPrintType}
                                isShowPrev={false}
                                isShowBack={true}
                                isShowFood={true}
                                onFoodClick={()=>{if(onFoodClick) onFoodClick(reserveId)}}
                                onBackClick={() => { if (onBackClick) onBackClick() }}
                                isShowNext={false}
                                isEnableNext={false}
                            />

                            <div className="no-print">
                                
                                <ReserveInfoComponent 
                                adminMode={true} 
                                setLoading={setLoading} 
                                reserve={reserve} 
                                showMessage={showMessage} />
                            </div>
                             <div className="only-print">
                                <PrintReserveInfoComponent 
                                setLoading={setLoading} 
                                showMessage={showMessage}
                                //key={`print_${reserve.id}_${version}`} // 🔥 اضافه کردن key
                                reserve={reserve} 
                                //version={version}
                                />
                            </div>


                            {(localStorage.getItem('role') == 'SuperAdmin' ||
                                localStorage.getItem('role') == 'Admin' ) &&
                                reserve.reserveStatus == 'FileUploadWaiting' 
                                 /*&&
                                reserve.period.getAdditionalFile*/ ?
                                <>
                                <div className="no-print">
        <br />
        {reserve?.period?.getAdditionalFile ? (
          <AdditionalFilesComponent
            reserve={reserve}
            period={reserve.period}
            setLoading={setLoading}
            showMessage={showMessage}
            isShowComment={false}
          />
        ) : null}
      </div>

                                    <EditableReserveComponent
                                        setLoading={setLoading}
                                        printType={printType}
                                        showMessage={showMessage}
                                        reserveId={reserve.id}
                                        period={reserve.period}
                                        showSteps={false}
                                        factorFirst={false}
                                        version={version}
                                        loadReserve={loadReserve}
                                       // onReserveUpdated={loadReserve} // 🔥 اضافه کردن این prop
                                        //   onReserveUpdated={() => loadReserve()}
                                    />

                                    

                                    <div className="no-print">
                                        <br />
                                        <div className='payment-section '>
                                            <PaymentComponent
                                                reserve={reserve}
                                                period={reserve.period}
                                                setLoading={setLoading}
                                                showMessage={showMessage}
                                                version={version}
                                                setVersion={setVersion}
                                            />
                                        </div>
                                    </div>

                                    <br />
                                </>
                                 :
                                (localStorage.getItem('role') == 'SuperAdmin' ||
                                localStorage.getItem('role') == 'Admin' ) &&
                                reserve?.reserveStatus == 'Payed' 
                                 /*&&
                                reserve.period.getAdditionalFile*/ ?
                                <>
                                <div className="no-print">
                                        <br />
                                        <div className='payment-section '>
                                            <PaymentComponent
                                                reserve={reserve}
                                                period={reserve.period}
                                                setLoading={setLoading}
                                                showMessage={showMessage}
                                                version={version}
                                                setVersion={setVersion}
                                            />
                                        </div>
                                    </div>

                                    <EditableReserveComponent
                                        setLoading={setLoading}
                                        printType={printType}
                                        showMessage={showMessage}
                                        reserveId={reserve.id}
                                        period={reserve.period}
                                        showSteps={false}
                                        factorFirst={false}
                                        version={version}
                                        loadReserve={loadReserve}
                                       // onReserveUpdated={loadReserve} // 🔥 اضافه کردن این prop
                                        //   onReserveUpdated={() => loadReserve()}
                                    />

                                    <div className="no-print">
        <br />
        {reserve?.period?.getAdditionalFile ? (
          <AdditionalFilesComponent
            reserve={reserve}
            period={reserve.period}
            setLoading={setLoading}
            showMessage={showMessage}
            isShowComment={false}
          />
        ) : null}
      </div>
                                                                 

                                    <br />
                                </>
                                                                 :
                                (localStorage.getItem('role') == 'SuperAdmin' ||
                                localStorage.getItem('role') == 'Admin' ) &&
                                !(reserve?.reserveStatus == 'FileUploadWaiting' 
                                ||reserve?.reserveStatus == 'Payed'
                                )
                                 /*&&
                                reserve.period.getAdditionalFile*/ ?
                                <>
                                    <EditableReserveComponent
                                        setLoading={setLoading}
                                        printType={printType}
                                        showMessage={showMessage}
                                        reserveId={reserve.id}
                                        period={reserve.period}
                                        showSteps={false}
                                        factorFirst={false}
                                        version={version}
                                        loadReserve={loadReserve}
                                       // onReserveUpdated={loadReserve} // 🔥 اضافه کردن این prop
                                        //   onReserveUpdated={() => loadReserve()}
                                    />

                                    <div className="no-print">
        <br />
        {reserve?.period?.getAdditionalFile ? (
          <AdditionalFilesComponent
            reserve={reserve}
            period={reserve.period}
            setLoading={setLoading}
            showMessage={showMessage}
            isShowComment={false}
            readOnly={true}
          />
        ) : null}
      </div>

                                    <div className="no-print">
                                        <br />
                                        <div className='payment-section '>
                                            <PaymentComponent
                                                reserve={reserve}
                                                period={reserve.period}
                                                setLoading={setLoading}
                                                showMessage={showMessage}
                                                version={version}
                                                setVersion={setVersion}
                                            />
                                        </div>
                                    </div>

                                    <br />
                                </>

                                :


                                <>
                                    <Row className='sectionTitle no-print'>
                                        <Col span={24}>
                                            <h2  >
                                                لیست نفرات
                                            </h2>
                                        </Col>
                                    </Row>

                                    <OthersComponent
                                        mode={'Show'}
                                        printType={printType}
                                        showTitleBar={false}
                                        setLoading={setLoading}
                                        showMessage={showMessage}
                                        reserveId={reserve.id}
                                        reserve={reserve}
                                    />

                                    <div className="no-print">
       
        {(localStorage.getItem('role') == 'Reception' ) &&
                                reserve?.period?.getAdditionalFile
                                 ? (
          <AdditionalFilesComponent
            reserve={reserve}
            period={reserve.period}
            setLoading={setLoading}
            showMessage={showMessage}
            isShowComment={false}
            readOnly={true}
          />
        ) : null}
      </div>

                                    <div className="no-print">
                                        <ReservePlaceAndTimeComponent setLoading={setLoading} showMessage={showMessage} reserve={reserve} />
                                    </div>
                                    <br />

                                    <AFactorComponent
                                        setLoading={setLoading}
                                        showMessage={showMessage}
                                        reserveId={reserve.id}
                                        printType={printType}
                                    />
                                </>
                            }
                             
                        </>
                }
            </> : <></>
    )
}
